export default {
  label: {
    mentionsText: 'Menciones',
  },
};
